module.exports = __webpack_public_path__ + "static/media/Euro2020Final-1428.41e88000.jpg";